// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import PageLayout from "cxfcomponents/LayoutContainers/PageLayout";

// Soft UI Dashboard PRO React page layout routes
// import pageRoutes from "page.routes";

// Images
import pattern from "assets/images/signup-bg.png";

function IllustrationLayout({ header = "", title = "", description = "", children }) {
  return (
    <PageLayout background="white">
      <SoftBox height="100vh" overflow="hidden">
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <SoftBox
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height="100vh"
              width="360px"
              mx="auto"
            >
              <SoftBox pt={3} px={3}>
                {!header ? (
                  <>
                    <SoftBox mb={1}>
                      <SoftTypography variant="h4" fontWeight="bold">
                        {title}
                      </SoftTypography>
                    </SoftBox>
                    <SoftTypography variant="body2" fontWeight="regular" color="text">
                      {description}
                    </SoftTypography>
                  </>
                ) : (
                  header
                )}
              </SoftBox>
              <SoftBox p={3}>{children}</SoftBox>
            </SoftBox>
          </Grid>
          <Grid size={{ xs: 6 }} display={{ xs: "none", md: "block" }}>
            <img
              src={pattern}
              alt="pattern-lines"
              style={{ objectFit: "cover", width: "100%", height: "100vh" }}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

// Typechecking props for the IllustrationLayout
IllustrationLayout.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default IllustrationLayout;
